import {
  CubeTimeDimensionGranularity,
  Weekdays,
} from '../enum/cube-schema.enum';
import { QueryLatestTeamAppMetricsRequestParamsDto } from '../dto/team-app-metrics/request/query-latest-team-app-metrics-request.dto';
import { QueryAllTimeAverageTeamAppMetricsRequestParamsDto } from '../dto/team-app-metrics/request/query-all-time-average-team-app-metrics-request.dto';
import { QueryAllTimeWeekdayAverageTeamAppMetricsRequestParamsDto } from '../dto/team-app-metrics/request/query-all-time-weekday-average-team-app-metrics-request.dto';
import { QueryAllTimeMaxAppMetricRequestParamsDto } from '../dto/team-app-metrics/request/query-all-time-max-app-metric-request.dto';
import { AllTimeAverageTeamAppMetricsResult } from '../dto/team-app-metrics/cube/mapped/all-time-average-team-app-metrics-result.dto';
import { AllTimeWeekdayAverageTeamAppMetricsResult } from '../dto/team-app-metrics/cube/mapped/all-time-weekday-average-team-app-metrics-result.dto';
import { LatestTeamAppMetricsResult } from '../dto/team-app-metrics/cube/mapped/latest-team-app-metrics-result.dto';
import { CubeConfigDto } from '../dto/common/request/cube-config.dto';
import { FilteredTeamAppMetricsResult } from '../dto/team-app-metrics/cube/mapped/filtered-team-app-metrics-result.dto';
import { TeamTimeSeriesAllTimeAverageResult } from '../dto/team-app-metrics/cube/mapped/team-time-series-all-time-average-result.dto';
import {
  TeamTimeSeriesResult,
  TeamUserTimeSeriesResult,
} from '../dto/team-app-metrics/cube/mapped/team-time-series-result.dto';
import { UserCountResult } from '../dto/team-app-metrics/cube/mapped/user-count-result.dto';
import { TeamTotalMetricsResult } from '../dto/team-app-metrics/cube/mapped/team-total-metrics-result.dto';
import { QueryTeamUserTimeSeriesAppMetricsRequestParamsDto } from '../dto/top-apps/request/query-team-user-time-series-app-metrics-request.dto';
import { QueryTeamAverageTimeSeriesAppMetricsRequestParamsDto } from '../dto/team-app-metrics/request/query-team-average-time-series-app-metrics-request.dto';
import { QueryTeamTimeSeriesAppMetricsRequestParamsDto } from '../dto/team-app-metrics/request/query-team-time-series-app-metrics-request.dto';
import { QueryTeamTimeSeriesAllTimeAverageAppMetricsRequestParamsDto } from '../dto/team-app-metrics/request/query-team-time-series-all-time-average-app-metrics-request.dto';
import { QueryLatestFilteredTeamAppMetricsRequestParamsDto } from '../dto/team-app-metrics/request/query-latest-filtered-team-app-metrics-request.dto';
import { QueryUserCountRequestParamsDto } from '../dto/team-app-metrics/request/query-user-count-request.dto';
import { QueryTeamTotalMetricsRequestParamsDto } from '../dto/team-app-metrics/request/query-team-total-metrics-request.dto';
import { QueryLatestFilteredTeamSubscriptionMetricsRequestParamsDto } from '../dto/team-app-metrics/request/query-latest-filtered-team-subscription-metrics-request.dto';
import { FilteredTeamSubscriptionMetricsResult } from '../dto/team-app-metrics/cube/mapped/filtered-team-subscriptions-result.dto';

export interface ITeamAnalyticsActivityRepository {
  queryLatestTeamAppMetrics(
    params: QueryLatestTeamAppMetricsRequestParamsDto,
    config: CubeConfigDto
  ): Promise<LatestTeamAppMetricsResult>;

  queryAllTimeAverageTeamAppMetrics(
    params: QueryAllTimeAverageTeamAppMetricsRequestParamsDto,
    config: CubeConfigDto
  ): Promise<AllTimeAverageTeamAppMetricsResult>;

  queryAllTimeWeekdayAverageTeamAppMetrics(
    params: QueryAllTimeWeekdayAverageTeamAppMetricsRequestParamsDto,
    config: CubeConfigDto
  ): Promise<AllTimeWeekdayAverageTeamAppMetricsResult>;

  queryAllTimeMaxAppMetric(
    params: QueryAllTimeMaxAppMetricRequestParamsDto,
    config: CubeConfigDto,
    metric: string
  ): Promise<number>;

  queryTeamUserTimeSeriesAppMetrics(
    params: QueryTeamUserTimeSeriesAppMetricsRequestParamsDto,
    config: CubeConfigDto
  ): Promise<TeamUserTimeSeriesResult[]>;

  queryTeamAverageTimeSeriesAppMetrics(
    params: QueryTeamAverageTimeSeriesAppMetricsRequestParamsDto,
    config: CubeConfigDto
  ): Promise<TeamTimeSeriesResult[]>;

  queryTeamTimeSeriesAppMetrics(
    params: QueryTeamTimeSeriesAppMetricsRequestParamsDto,
    config: CubeConfigDto
  ): Promise<TeamTimeSeriesResult[]>;

  queryTeamTimeSeriesAllTimeAverageAppMetrics(
    params: QueryTeamTimeSeriesAllTimeAverageAppMetricsRequestParamsDto,
    config: CubeConfigDto
  ): Promise<TeamTimeSeriesAllTimeAverageResult>;

  queryLatestFilteredTeamAppMetrics(
    params: QueryLatestFilteredTeamAppMetricsRequestParamsDto,
    config: CubeConfigDto
  ): Promise<Omit<FilteredTeamAppMetricsResult, 'userCount'>[]>;

  queryLatestFilteredTeamSubscriptionMetrics(
    params: QueryLatestFilteredTeamSubscriptionMetricsRequestParamsDto,
    config: CubeConfigDto
  ): Promise<Omit<FilteredTeamSubscriptionMetricsResult, 'userCount'>[]>;

  queryUserCount(
    params: QueryUserCountRequestParamsDto,
    config: CubeConfigDto
  ): Promise<UserCountResult[]>;

  queryTeamTotalMetrics(
    params: QueryTeamTotalMetricsRequestParamsDto,
    config: CubeConfigDto
  ): Promise<TeamTotalMetricsResult>;
}
